import { TimelineEntityMeta } from "store/apis/filingsTimeline";

export const getYearsWithFilings = (
  entities: TimelineEntityMeta[]
): number[] => {
  const years = entities.flatMap((entity) =>
    entity.year_stats
      .filter((stat) => stat.filing_count > 0)
      .map((stat) => stat.year)
  );

  return Array.from(new Set(years)).sort((a, b) => b - a);
};
